import useIsMobile from '@/hooks/useIsMobile';
import usePasswordReseted from './usePasswordReseted';
import PasswordResetedDesktop from './desktop';
import PasswordResetedMobile from './mobile';

function PasswordReseted() {
  const isMobile = useIsMobile(992);
  const viewModel = usePasswordReseted();

  return isMobile ? <PasswordResetedMobile viewModel={viewModel} /> : <PasswordResetedDesktop viewModel={viewModel} />;
}

export default PasswordReseted;
